import { Directive, Input, ElementRef, OnChanges } from '@angular/core';

/**
 * Aplica foco automÃ¡tiamente em um elemento, com um delay de 500ms
 *
 * @example
 * <input type="text" [uexAutofocus]="true" />
 */
@Directive({
  selector: '[uexAutofocus]'
})
export class AutofocusDirective implements OnChanges {
  @Input('uexAutofocus') private _autofocus = true;

  /**
   * @ignore
   */
  constructor(
    private _elementRef: ElementRef
  ) { }

  public ngOnChanges() {
    this._doFocus();
  }

  private _doFocus() {
    if (this._autofocus) {
      setTimeout(() => {
        this._elementRef.nativeElement.focus();
      }, 500);
    }
  }
}
